import React from 'react'
import { withAuthorization } from '../session';
import InstitutionalItem from './InstitutionalItem';
import Loader from 'react-loader-spinner';
import Modal from 'react-modal';
import modalStyle from '../styles/modal'
import EmptyList from '../useful/EmptyList';
import InstitutionalForm from './InstitutionalForm';

Modal.setAppElement('#root');
class Institutional extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            institutional: [],
            error: {
                isShow: false,
                message: ''
            }
        }
    }

    componentDidMount() {
        this.setState({ loading: true });
        this.listenInstitutional();
    }

    componentWillUnmount() {
        this.props.firebase.institutionals().off();
    }

    listenInstitutional = () => {
        this.props.firebase.institutionals().off();
        this.props.firebase.institutionals().on('value', (snapshot) => {
            const institutionalObject = snapshot.val();
            let list = [];
            if (institutionalObject) {
                list = Object.keys(institutionalObject).map(key => ({
                    ...institutionalObject[key],
                    uid: key,
                }));
            }
            this.setState({
                institutional: list,
                loading: false,
            });

        });
    }

    handleUploadFile = (fileUrl, item) => {
        this.props.firebase.institutional(item.uid)
            .set({
                title: item.title,
                latitude: item.latitude || null,
                longitude: item.longitude || null,
                fileUrl: fileUrl,
            })
            .then(() => {
                // do nothing
            })
            .catch(error => {
                this.showErrorModal("Los sentimos, ocurrió un error al subir el archivo.");
            });
    }

    handleSubmit = (title, latitude, longitude) => {
        this.props.firebase.institutionals().push({
            title: title,
            latitude: parseFloat(latitude),
            longitude: parseFloat(longitude)
        }).then(() => {
            // do nothing
        }).catch(error => {
            this.showErrorModal("Los sentimos, no se pudo crear este elemento.");
            console.log(error);
        });
    }

    handleDelete = (item) => {
        const itemUid = item.uid;

        this.props.firebase.institutional(itemUid).remove()
            .then(() => {
                // do nothing
            })
            .catch(error => {
                this.showErrorModal("Los sentimos, no se pudo eliminar este elemento.");
                console.log(error);
            });
    }

    showErrorModal = (message) => {
        this.setState({
            error: {
                isShow: true,
                message: message
            }
        });
    }

    closeErrorModal = () => {
        this.setState({
            error: {
                isShow: false,
                message: ''
            }
        });
    }

    render() {
        const { institutional, loading, error } = this.state;

        const time = new Date().getTime();
        const institutionalList = institutional.length > 0 ?
            institutional.map((item, i) => {
                return (
                    <InstitutionalItem
                        key={item.uid + time}
                        item={item}
                        handleDelete={this.handleDelete}
                        handleUploadFile={this.handleUploadFile}
                        showErrorModal={this.showErrorModal}
                    />
                )
            }) :
            <tr>
                <td colSpan="10">
                    <EmptyList />
                </td>
            </tr>

        return (
            <div >
                <InstitutionalForm key={time} handleSubmit={this.handleSubmit} />

                <div>
                    <h5 >Institutional: listado de archivos</h5>

                    {(!loading) ?
                        <div className="table-responsive-md">
                            <table className="table table-sm ">
                                <thead className="thead-dark">
                                    <tr>
                                        <th className="pr-2 pl-2" scope="col">Título</th>
                                        <th className="pr-2 pl-2 text-center" scope="col">Ubicación</th>
                                        <th className="pr-2 pl-2" scope="col">Archivo</th>
                                        <th className="pr-2 pl-2 text-right" scope="col">Opciones</th>
                                    </tr>
                                </thead>
                                <tbody style={{ fontSize: '0.9em' }}>
                                    {institutionalList}
                                </tbody>
                            </table>
                        </div>
                        :
                        <div className="nav justify-content-center row">
                            <Loader className="mt-4"
                                type="ThreeDots"
                                color="#263238"
                                height={60}
                                width={60}
                                timeout={0} />
                        </div>
                    }
                </div>

                <Modal
                    isOpen={error.isShow}
                    contentLabel="Modal Example"
                    style={modalStyle}
                    onRequestClose={this.closeErrorModal}>
                    <div className="" style={{ minWidth: '300px', maxWidth: '400px' }}>
                        <h5 className="card-title">Error</h5>
                        <p className="card-text text-break">{error.message}</p>

                        <div className="nav justify-content-end">
                            <button onClick={this.closeErrorModal} className="btn btn-sm btn-dark">Cerrar</button>
                        </div>
                    </div>

                </Modal>
            </div>
        );
    }

}

const condition = authUser => !!authUser;
export default withAuthorization(condition)(Institutional);